import { createTheme as createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import deepPurple from '@material-ui/core/colors/deepPurple';

// component overrides
import bottomNavigationAction from './components/bottomNavigationAction';
import button from './components/button';
import chip from './components/chip';
import dialogAction from './components/dialogAction';
import fab from './components/fab';
import menu from './components/menu';
import radio from './components/radio';
import select from './components/select';
import speedDial from './components/speedDial';
import switchComp from './components/switch';
import tabs from './components/tabs';
import textfields from './components/textfields';
import tooltip from './components/tooltip';

export function createTheme(themeJson) {

    return createMuiTheme({
        // Inject the default theme palette etc from the supplied theme json
        ...themeJson,

        typography: {
            fontFamily: "'Open Sans', 'sans-serif'"
        },

        // Apply component overrides based on the theme palette
        overrides: {
            ...(bottomNavigationAction(themeJson)),
            ...(button(themeJson)),
            ...(chip(themeJson)),
            ...(dialogAction(themeJson)),
            ...(fab(themeJson)),
            ...(menu(themeJson)),
            ...(radio(themeJson)),
            ...(select(themeJson)),
            ...(speedDial(themeJson)),
            ...(switchComp(themeJson)),
            ...(tabs(themeJson)),
            ...(textfields(themeJson)),
            ...(tooltip(themeJson)),
        }
    });
}

export const defaultTheme = () => createTheme({
    palette: {
        primary: deepPurple,
        secondary: blue,
        background: {
            default: '#fff',
            paper: '#fff',
            surface: '#fff'
        },
        common: {
            black: "#000",
            white: "#fff",
            border: "gainsboro"
        },
        text: {
            "primary": "#00313B",
            "secondary": "#007193",
            "tertiary": "#00A19D",
            "disabled": "rgba(129, 131, 134, 1)",
            "hint": "rgba(0, 0, 0, 0.38)"
        }
    }
});